import * as Color from "../../general/Color";
import { CodeTheme } from "./CodeTheme";

/**
 * The light mode code theme.
 */
export const LightModeTheme: CodeTheme = {
  background: Color.White,
  primary: Color.fromString("#001080"),
  comment: Color.fromString("#008000"),
  prolog: Color.fromString("#008000"),
  doctype: Color.fromString("#008000"),
  cdata: Color.fromString("#008000"),
  punctuation: Color.fromString("#0431fa"),
  namespace: Color.withAlpha(Color.fromString("#001080"), 0.7),
  property: Color.fromString("#0000ff"),
  tag: Color.fromString("#0000ff"),
  boolean: Color.fromString("#0000ff"),
  number: Color.fromString("#098658"),
  constant: Color.fromString("#0000ff"),
  symbol: Color.fromString("#0000ff"),
  deleted: Color.fromString("#0000ff"),
  selector: Color.fromString("#a31515"),
  attrName: Color.fromString("#a31515"),
  string: Color.fromString("#a31515"),
  char: Color.fromString("#a31515"),
  builtIn: Color.fromString("#a31515"),
  inserted: Color.fromString("#a31515"),
  operator: Color.fromString("#800000"),
  entity: Color.fromString("#a31515"),
  url: Color.fromString("#a31515"),
  cssString: Color.fromString("#a31515"),
  atRule: Color.fromString("#af00db"),
  attrValue: Color.fromString("#af00db"),
  keyword: Color.fromString("#af00db"),
  className: Color.fromString("#795e26"),
  function: Color.fromString("#795e26"),
  regex: Color.fromString("#e50000"),
  important: Color.fromString("#e50000"),
  variable: Color.fromString("#e50000"),
};
